import { render, staticRenderFns } from "./Takeaway.vue?vue&type=template&id=eddf23b4&scoped=true&"
import script from "./Takeaway.vue?vue&type=script&lang=js&"
export * from "./Takeaway.vue?vue&type=script&lang=js&"
import style0 from "./Takeaway.vue?vue&type=style&index=0&id=eddf23b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddf23b4",
  null
  
)

export default component.exports